/* Combobox remoto de dominios, filtrable por tipo y padre (cascada) */
import { useLazyQuery } from "@apollo/client";
import { SelectProps } from "antd";
import { DOMAINSGENERAL } from "./ComboboxGQL";
import RemoteComboBox from "../../../shared/RemoteComboBox";

interface DomainComboboxProps extends SelectProps<string> {
    pageSize?: number;
    type?: string;
    parentid?: string;
}

const DomainCombobox: React.FC<DomainComboboxProps> = ({
    pageSize = 7,
    type,
    parentid,
    ...props
}) => {
    const DEFAULT_VARIABLES = parentid ? {
        type,
        parentid,
    } : {
        type,
    };

    const [getData, { data, loading, error }] = useLazyQuery(
        DOMAINSGENERAL,
        {
            fetchPolicy: "no-cache",
            variables: {
                ...DEFAULT_VARIABLES,
                search: "",
                combo: true,
                table: false
            },
        }
    );

    return (
        <RemoteComboBox
            {...props}
            optionIdKey={"name"}
            optionValueKey={"name"}
            pageSize={pageSize}
            defaultVariables={DEFAULT_VARIABLES}
            fetchData={getData}
            data={data}
            dataKey={"domains"}
            loading={loading}
            error={error}
            addDropRender
        />
    );
};

export default DomainCombobox;
